import React from 'react';

const styles = {
  unreadBadge: {
    position: 'relative',
    display: 'inline-block',
    marginLeft: '10px', // Adjust this for positioning
  },
  badge: {
    position: 'absolute',
    top: '-12px',
    right: '-5px',
    backgroundColor: '#d51b1b',
    color: 'white',
    borderRadius: '50%',
    padding: '4px 8px',
    fontSize: '12px',
  },
};

const UnreadMessageBadge = ({ unreadCount }) => {
  return (
    <div style={styles.unreadBadge}>
      {unreadCount > 0 && <span style={styles.badge}>{unreadCount}</span>}
    </div>
  );
};

export default UnreadMessageBadge;
